import { render, staticRenderFns } from "./EditSContract.vue?vue&type=template&id=12b9d70c&scoped=true&"
import script from "./EditSContract.vue?vue&type=script&lang=js&"
export * from "./EditSContract.vue?vue&type=script&lang=js&"
import style0 from "./EditSContract.vue?vue&type=style&index=0&id=12b9d70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b9d70c",
  null
  
)

export default component.exports